import {useState} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import {useQueryClient} from '@tanstack/react-query';
import BurgerMenu, {MenuGroup} from '../navigation/burgerMenu';
import routes from '../routes/routes';
import {useOrganizerStore} from '../../common/stores/useOrganizerStore';
import {useAuthStore} from '../../common/stores/useAuthStore';
import {useUiStore} from '../../common/stores/useUiStore';

// Admin actions that must stay reachable even when no organizer is selected.
const adminMenuGroups: MenuGroup[] = [
  {
    title: 'Navigation',
    links: [{label: 'Select Organizer', to: routes.organizer}],
  },
  {
    title: 'Admin',
    links: [
      {label: 'All Activities', to: routes.activities},
      {label: 'Users', to: routes.users},
      {label: 'Support', to: routes.support},
      {label: 'Cities', to: routes.cities},
      {label: 'Tags', to: routes.tags},
      {label: 'Tokens', to: routes.tokens},
      {label: 'Challenges', to: routes.challenges},
      {label: 'Approve Places', to: routes.approvePlaces},
      {label: 'Approve Business', to: routes.approveBusiness},
    ],
  },
];

export const AdminLayout = () => {
  const isNavOpen = useUiStore(state => state.isNavOpen);
  const [isLogoutHovered, setIsLogoutHovered] = useState(false);
  const clearOrganizer = useOrganizerStore(state => state.clearOrganizer);
  const clearSession = useAuthStore(state => state.clearSession);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleLogout = () => {
    clearOrganizer();
    clearSession();
    // The next admin to sign in on this tab must not see this one's lists.
    queryClient.clear();
    navigate(routes.signIn, {replace: true});
  };

  return (
    <div
      className={`app-shell admin-shell ${isNavOpen ? 'nav-open' : ''}`}
      style={layoutWrapperStyle}>
      <div style={burgerWrapperStyle}>
        <BurgerMenu groups={adminMenuGroups} />
      </div>

      <button
        onClick={handleLogout}
        onMouseEnter={() => setIsLogoutHovered(true)}
        onMouseLeave={() => setIsLogoutHovered(false)}
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          zIndex: 1100,
          backgroundColor: isLogoutHovered ? '#ff4d4d' : 'transparent',
          color: isLogoutHovered ? '#fff' : '#ff4d4d',
          border: '2px solid #ff4d4d',
          padding: '10px 20px',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: '0.8rem',
          transition: 'all 0.3s ease',
        }}>
        Logout
      </button>

      <main>
        <Outlet />
      </main>
    </div>
  );
};

const layoutWrapperStyle: React.CSSProperties = {
  backgroundColor: '#1a1a1a',
  minHeight: '100vh',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
};

const burgerWrapperStyle: React.CSSProperties = {
  position: 'fixed',
  top: 20,
  left: 10,
  zIndex: 1100,
};
